// Datos del usuario que inicia sesión
export const setAuthUserData = (userData) => {
  localStorage.setItem("authUserData", JSON.stringify(userData));
};

export const getAuthUserData = () => {
  const data = localStorage.getItem("authUserData");
  return data ? JSON.parse(data) : null;
};

export const removeAuthUserData = () => {
  localStorage.removeItem("authUserData");
};

// Estado del menú lateral
export const setSidebarState = (sidebarState) => {
  localStorage.setItem("sidebarState", JSON.stringify(sidebarState));
};

export const getSidebarState = () => {
  const data = localStorage.getItem("sidebarState");
  return data ? JSON.parse(data) : null;
};

// obtener idioma de la web seleccionado seleccionado con i18n
export const getLanguage = () => {
  return localStorage.getItem("i18nextLng") || "es";
};
